// TO UPDATE FOR MICRO FRONTENDS

import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { AccountType } from '../../app/models/enums/account-types.enum';
import { CustomerService } from './customer.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private _loggedInObservable = new BehaviorSubject<null>(null);

  public loggedInObservable: Observable<null> = this._loggedInObservable.asObservable();

  private _unsubscribe$ = new Subject();

  constructor(
    private customerService: CustomerService,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private route: ActivatedRoute) {
    this.msalBroadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None || status === InteractionStatus.HandleRedirect),
      takeUntil(this._unsubscribe$)
    )
    .subscribe(status => {
        let accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.msalService.instance.setActiveAccount(accounts[0]);
          if (this.route) {
            this.route.queryParamMap.subscribe(param => {
              this.setCompanyFromRoute(param);
            });
          }
          this.setSelectedCompanyToDefault();
          this._loggedInObservable.next(null);
        } else {
          if (status === InteractionStatus.None) {
            this.msalService.loginRedirect();
          }
        }
    });
  }
  
  isLoggedIn(): boolean {
    var tmp = this.msalService.instance.getAllAccounts();
    let acct = this.msalService.instance.getActiveAccount();
    if (acct) {
      return true;
    } else {
      return false;
    }
  }

  getCompanyId(): number {
    let companyId = localStorage.getItem('selectedCompany');
    if (companyId === undefined || companyId === null || companyId === '') {
        return 0;
    }
    else {
        return parseInt(companyId);
    }
  }

  getAllCustomerIds(): number[] {
    let customerList;
    let acct = this.msalService.instance.getActiveAccount();
    if (acct) {
      customerList = acct.idTokenClaims['com.tql.customer']
    }
    if (customerList) {
      return customerList.map(customerId => parseInt(customerId));
    }
    else {
      return []
    }
  }

  getAccountType(): number {
    let accountType = localStorage.getItem('selectedCompanyAccountType');

    if (accountType === undefined || accountType === null || accountType === '') {
      return 0;
    }
    else {
      return parseInt(accountType);
    }

  }

  private setSelectedCompanyToDefault() {
    let customerList = this.getAllCustomerIds();

    var previousCompanyId = this.getCompanyId();
    var previousAccountType = this.getAccountType();

    if (previousCompanyId !== 0 && previousAccountType !== 0 &&
        previousAccountType === AccountType.Customer &&
        this.getAllCustomerIds().includes(previousCompanyId)) {
      // if there is a user saved locally and it's one of the token users then return
      return;
    }

    if (customerList.length > 0) {
      // Default to the first customer if the query params aren't there or they don't match a company
      console.log(`Defaulting selected company to first customer.`);
      this.setSelectedCompany(customerList[0], AccountType.Customer);
      localStorage.setItem('oidccustomer', 'true');
    }
    else {
      // Not sure if this would ever happen, not sure what to do in this case (Log out?)
      console.log(`User isn't associated with any customers or distributors.`);
      this.setSelectedCompany();
    }
  }

  setCompanyFromRoute(params: ParamMap) {
    let customerId = Number(params.get('CompanyId'));
    let accountType = Number(params.get('AccountType'));
    
    if ((customerId && customerId > 0) &&
        (accountType && accountType > 0)){
      this.setSelectedCompany(customerId, accountType);
    }

  }

  setSelectedCompany(companyId: number = 0, accountType: AccountType = 0) {
    console.log(`Setting selected company to ${companyId} - ${accountType}`);
    this.customerService.setLmCustomerTraxSettings(companyId);
    localStorage.setItem('selectedCompany', companyId.toString());
    localStorage.setItem('selectedCompanyAccountType', accountType.toString());
  }

  logout() {
    this.msalService.logoutRedirect().subscribe(() => {
      localStorage.removeItem('oidcuser');
      localStorage.removeItem('oidccustomer');
      localStorage.removeItem('traxpath');
      localStorage.removeItem('selectedCompany');
      localStorage.removeItem('selectedCompanyAccountType');
      this._loggedInObservable.next(null);
    });
  }
}